import React, { useEffect, useState } from 'react';
import { Form, Input, DatePicker, Button, Upload, Select, message, Checkbox } from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';
import { UploadOutlined } from '@ant-design/icons';
import API_BASE_URL from '../../config/api';
import getFileUrl from '../../utils/fileUrl';

const MonkForm = ({ initialData, onFinish }) => {
  const [form] = Form.useForm();
  const [temples, setTemples] = useState([]);
  const [fileList, setFileList] = useState([]); //แสดงรูปพระเดิมที่อัพโหลดไว้แล้ว

  useEffect(() => {
    const fetchTemples = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/get-temples`);
        //console.log('temple', res.data.temples);
        setTemples(res.data.temples);
      } catch (err) {
        console.error(err);
        message.error('ไม่สามารถโหลดรายชื่อวัดได้');
      }
    };
    fetchTemples();
  }, []);

  useEffect(() => {
    if (initialData) {
      form.setFieldsValue({
        ...initialData,
        birthdate: dayjs(initialData.birthdate?initialData.birthdate:'2025-06-02'),
        ordination_date: dayjs(initialData.ordination_date?initialData.ordination_date:'2025-06-02'),
      });

      if (initialData.photo) {
        setFileList([
          {
            uid: '-1',
            name: initialData.photo,
            status: 'done',
            url: getFileUrl(initialData.photo),
          },
        ]);
      }

    }
  }, [initialData]);

  //เพิ่มระบบอัพโหลดภาพ
  const onSubmit = async (values) => {
    try {
      const token = localStorage.getItem('token');

      const formData = new FormData();
      formData.append('national_id', values.national_id);
      formData.append('first_name_th', values.first_name_th);
      formData.append('last_name_th', values.last_name_th);
      formData.append('dharma_name', values.dharma_name);

      if (values.birthdate) {
        formData.append('birthdate', values.birthdate.format('YYYY-MM-DD'));
      }

      if (values.ordination_date) {
        formData.append('ordination_date', values.ordination_date.format('YYYY-MM-DD'));
      }

      formData.append('temple_id', values.temple_id);
      formData.append('is_upajjhaya', values.is_upajjhaya); // ถ้ามีฟิลด์นี้

      if (values.photo && values.photo.file) {
        formData.append('photo', values.photo.file);
      }

      //console.log('monkId', initialData.monkId);

      if (initialData) {
        await axios.put(`${API_BASE_URL}/api/monks/${initialData.monkId}`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        message.success('อัปเดตข้อมูลสำเร็จ');

      } else {
        await axios.post(`${API_BASE_URL}/api/monks`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        message.success('เพิ่มข้อมูลสำเร็จ');
      }

      onFinish();
    } catch (err) {
      console.error(err);
      message.error('ไม่สามารถบันทึกข้อมูลได้');
    }
  };


  return (
    <Form layout="vertical" form={form} onFinish={onSubmit}>
      <Form.Item name="national_id" label="เลขบัตรประชาชน" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name="first_name_th" label="ชื่อ (ไทย)" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name="last_name_th" label="นามสกุล (ไทย)" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name="dharma_name" label="ฉายา">
        <Input />
      </Form.Item>
      <Form.Item name="birthdate" label="วันเกิด" rules={[{ required: false }]}>
        <DatePicker />
      </Form.Item>
      <Form.Item name="is_upajjhaya" valuePropName="checked">
        <Checkbox>เป็นพระอุปัชฌาย์</Checkbox>
      </Form.Item>
      <Form.Item name="ordination_date" label="วันบรรพชา/อุปสมบท">
        <DatePicker />
      </Form.Item>
      <Form.Item
        label="วัดที่สังกัด"
        name="temple_id"
        rules={[{ required: true, message: 'กรุณาเลือกวัดที่สังกัด' }]}
      >
        <Select
          placeholder="ค้นหาหรือเลือกวัด"
          showSearch
          filterOption={(input, option) =>
            (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
          }
        >
          {temples.map(t => (
            <Select.Option key={t.id} value={t.id}>
              {t.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="photo"
        label="รูปพระ"
      >
        <Upload
          listType="picture"
          beforeUpload={() => false}
          maxCount={1}
          defaultFileList={
            initialData?.photo
              ? [{
                uid: '-1',
                name: initialData.photo,
                status: 'done',
                url: getFileUrl(initialData.photo),
              }]
              : null
          }
          onRemove={async () => {
            try {
              const token = localStorage.getItem('token');
              await axios.delete(`${API_BASE_URL}/api/monks/${initialData.id}/photo`, {
                headers: { Authorization: `Bearer ${token}` },
              });
              message.success('ลบรูปสำเร็จ');
              form.setFieldValue('photo', null);
              setFileList([]);
            } catch (err) {
              message.error('ลบรูปไม่สำเร็จ');
            }
          }}
        >
          <Button icon={<UploadOutlined />}>เลือกไฟล์</Button>
        </Upload>
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          บันทึก
        </Button>
      </Form.Item>
    </Form>
  );
};

export default MonkForm;
